var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content wish_bets_pages" }, [
    _vm.wishBetAuthorizationToken
      ? _c(
          "div",
          [
            !_vm.showPageTitleInHeader ||
            (_vm.showPageTitleInHeader && _vm.tabletAndAbove)
              ? _c("h1", [_vm._v(_vm._s(_vm.$t("PageTitle.placedbets")))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "scan_bet_btn",
                on: {
                  click: function($event) {
                    return _vm.openBarcodeScanner()
                  }
                }
              },
              [
                _c("span", { staticClass: "barcode_icon" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("WishBet.ScanBarcode")))])
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0284564", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0284564","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/WishBet/PlacedBetsPage.vue
// module id = null
// module chunks = 